/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type GetApiWorkspaceServiceV1WorkspacesIdErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class GetApiWorkspaceServiceV1WorkspacesIdErrorResponse extends Error {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: GetApiWorkspaceServiceV1WorkspacesIdErrorResponseData;

  constructor(err: GetApiWorkspaceServiceV1WorkspacesIdErrorResponseData) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "GetApiWorkspaceServiceV1WorkspacesIdErrorResponse";
  }
}

/** @internal */
export const GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$inboundSchema:
  z.ZodType<
    GetApiWorkspaceServiceV1WorkspacesIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new GetApiWorkspaceServiceV1WorkspacesIdErrorResponse(v);
    });

/** @internal */
export type GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$Outbound = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/** @internal */
export const GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$outboundSchema:
  z.ZodType<
    GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$Outbound,
    z.ZodTypeDef,
    GetApiWorkspaceServiceV1WorkspacesIdErrorResponse
  > = z.instanceof(GetApiWorkspaceServiceV1WorkspacesIdErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$ {
  /** @deprecated use `GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$inboundSchema;
  /** @deprecated use `GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$outboundSchema;
  /** @deprecated use `GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$Outbound` instead. */
  export type Outbound =
    GetApiWorkspaceServiceV1WorkspacesIdErrorResponse$Outbound;
}
